import { render } from "./TtHorizontal.vue?vue&type=template&id=16ccaade"
import script from "./TtHorizontal.vue?vue&type=script&lang=js"
export * from "./TtHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__